import type { CSSProperties, HTMLAttributes } from "react";

const DEFAULT_CONTAINER_STYLE: CSSProperties = {
  width: "100%",
  minHeight: 100,
  overflowX: "hidden",
  boxSizing: "border-box",
};

type H5ContainerProps = HTMLAttributes<HTMLDivElement>;

function H5Container({ style, children, ...rest }: H5ContainerProps) {
  return (
    <div
      {...rest}
      style={{
        ...DEFAULT_CONTAINER_STYLE,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default H5Container;
